import { PaddingVisualisationSettings } from 'modules/settingsContainer/common/data/PaddingVisualisationSettings';
import { IncisionsSelectorPositionSettings } from 'modules/settingsContainer/common/IncisionsSelectorPositionSettings';
import { AxisSettings } from 'modules/settingsContainer/common/view/AxisSettings';
import { BooleanTipsSettings } from 'modules/settingsContainer/common/view/BooleanTipsSettings';
import { DefaultViewSettings } from 'modules/settingsContainer/common/view/DefaultViewSettings';
import { ExtendedSettings } from 'modules/settingsContainer/common/view/ExtendedSettings';
import { showLegendTitle } from 'modules/settingsContainer/common/view/LegendSettings/constants';
import { ZoomSettings } from 'modules/settingsContainer/common/view/VerticalZoomSettings';
import { MainContainerSettings } from 'modules/settingsContainer/MainContainerSettings';
import {
  onChangeHorizontalZoomChange,
  onChangePaddingVisualisation,
  onChangeVerticalZoomChange,
  onIncisionSelectorPositionChange,
  onShowTipsChange,
  onVisualMapSettingsChange,
  onXAxisIncisionChange,
  onYAxisIncisionChange,
} from 'modules/visualisations/Bubble/settings/ViewTab/constants';
import { onVisibleIncisionSelectorChange } from 'modules/visualisations/Heatmap/settings/ViewTab/constants';
import React from 'react';
import SubSection from 'shared/ui/subSection';
import { defaultBubbleDataSettings, defaultBubbleViewSettings } from 'store/reducers/visualisations/constants';
import { useGetActiveVisualisationSettings } from 'utils/hooks/visualisation/getActiveVisualisationSettings';

export const ViewTab = () => {
  const { viewSettings, positionConfig } = useGetActiveVisualisationSettings({
    defaultView: defaultBubbleViewSettings,
    defaultData: defaultBubbleDataSettings,
  });

  return (
    <>
      <DefaultViewSettings
        SecondSlot={
          <>
            <IncisionsSelectorPositionSettings
              value={viewSettings.incisionSelectorPosition}
              onChange={onIncisionSelectorPositionChange}
              onChangeVisible={onVisibleIncisionSelectorChange}
              isVisible={viewSettings.isVisible}
            />
            <ExtendedSettings
              title={showLegendTitle}
              value={viewSettings.visualMapSettings}
              onChange={onVisualMapSettingsChange}
            />
          </>
        }
        ThirdSlot={
          <>
            <BooleanTipsSettings value={viewSettings.showTips} onChange={onShowTipsChange} />
            <AxisSettings
              isRotated={false}
              value={viewSettings.axisXIncisionSettings}
              onChange={onXAxisIncisionChange}
              titleText="Ось разрезов X"
              type="incision"
              disabledLabelSize
            />
            <AxisSettings
              isRotated={false}
              value={viewSettings.axisYIncisionSettings}
              onChange={onYAxisIncisionChange}
              titleText="Ось разрезов Y"
              type="incision"
              disabled={{ positionAxis: true }}
              disabledLabelSize
              disabledOrderValue
            />
            <MainContainerSettings titleText="Приближение">
              <SubSection>
                <ZoomSettings
                  title="Приближение по вертикали"
                  value={viewSettings.verticalZoom}
                  onChange={onChangeVerticalZoomChange}
                />
              </SubSection>
              <SubSection>
                <ZoomSettings
                  title="Приближение по горизонтали"
                  value={viewSettings.horizontalZoom}
                  onChange={onChangeHorizontalZoomChange}
                />
              </SubSection>
            </MainContainerSettings>
            <PaddingVisualisationSettings value={viewSettings.visualisationPaddings} onChange={onChangePaddingVisualisation} />
          </>
        }
        viewSettings={viewSettings}
        positionConfig={positionConfig}
      />
    </>
  );
};
